import React from 'react';
import { Flex } from 'antd';
import { Title } from 'components/Base/Typography';
import { BannerReportData } from 'redux/apiSlice/reporting.slice';
import { Tooltip } from 'components/Base/Tooltip';
import { MetricTitle } from './SummaryBar.styles';

export const SummaryBar = ({ data }: { data?: BannerReportData[] }) => {
  // Filter out hidden banner data
  const visibleData = data?.filter(d => !d.hidden);

  return (
    <Flex
      justify="space-around"
      align="flex-start"
      style={{
        padding: 24,
        background: '#fff',
        border: '1px solid #f0f0f0',
        overflowX: 'scroll',
      }}
      data-cy="summary-bar"
    >
      {visibleData?.map(d => (
        <Flex
          key={d.metric}
          vertical
          align="start"
          style={{
            padding: '0 32px',
            borderRight:
              d.metric === visibleData[0].metric ? '1px solid #f0f0f0' : 'none',
            minWidth: '150px',
          }}
          data-cy="summary-bar-metric"
        >
          <Tooltip title={d.metric}>
            <MetricTitle
              level={5}
              style={{ fontWeight: 400 }}
              data-cy="summary-bar-metric-title"
            >
              {d.metric}
            </MetricTitle>
          </Tooltip>
          <Title
            level={1}
            style={{ margin: 0, marginTop: 8 }}
            data-cy="summary-bar-metric-value"
          >
            {d.value}
          </Title>
        </Flex>
      ))}
    </Flex>
  );
};
